module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help.22dae4bf.png";